<template>
  <v-footer class="app-footer" padless>
    <span class="app-footer__text">© {{ year }} {{ footer }}</span>
  </v-footer>
</template>

<script>
import { getToday } from '@/utils/DateUtil';

export default {
  name: "Footer",
  props: {
    footer: {
      type: String,
      default: ""
    }
  },
  data(){
    return {
      year: getToday().toFormat('yyyy')
    }
  }
};
</script>
<style scoped>
.v-footer.app-footer {
  justify-content: center;
  padding: 10px 16px;
  border-top: 1px solid var(--app-line);
  background: var(--app-nav-bg);
}
.app-footer__text {
  font-size: 12px;
  color: var(--app-nav-text);
}
</style>
